import React, { memo } from 'react'
import { FavoriteButton, FavoriteButtonActive } from './styled'
import { useDispatch, useSelector } from 'react-redux'
import { removeFromFavorites, addToFavorites, selectNftFavorites } from 'state/nftFavorites/slice'

function Favorite({ slug }: { slug: string }) {
  const dispatch = useDispatch()
  const { favorites } = useSelector(selectNftFavorites)

  return favorites.includes(slug) ? (
    <FavoriteButtonActive onClick={() => dispatch(removeFromFavorites(slug))} />
  ) : (
    <FavoriteButton onClick={() => dispatch(addToFavorites(slug))} />
  )
}

export default memo(Favorite)
